import { createApp } from "vue";
import App from "./App.vue"
import router from "./router"
import store from "./store"

import "primevue/resources/themes/saga-blue/theme.css"
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

import PrimeVue from "primevue/config";
import ConfirmationService from "primevue/confirmationservice";
import ToastService from "primevue/toastservice";

import Badge from "primevue/badge";
import Button from "primevue/button";
import Calendar from "primevue/calendar";
import Card from "primevue/card";
import Carousel from "primevue/carousel";
import Checkbox from "primevue/checkbox";
import Column from "primevue/column";
import ConfirmDialog from "primevue/confirmdialog";
import DataTable from "primevue/datatable";
import Dialog from "primevue/dialog";
import Divider from "primevue/divider";
import Dropdown from "primevue/dropdown";
import FileUpload from "primevue/fileupload";
import InlineMessage from "primevue/inlinemessage";
import InputNumber from "primevue/inputnumber";
import InputSwitch from 'primevue/inputswitch';
import InputText from "primevue/inputtext";
import Menu from "primevue/menu";
import MultiSelect from "primevue/multiselect";
import OverlayPanel from "primevue/overlaypanel";
import Paginator from "primevue/paginator";
import Password from "primevue/password";
import PickList from "primevue/picklist";
import ProgressBar from "primevue/progressbar";
import ProgressSpinner from "primevue/progressspinner";
import RadioButton from 'primevue/radiobutton';
import ScrollTop from "primevue/scrolltop";
import SelectButton from "primevue/selectbutton";
import Skeleton from 'primevue/skeleton';
import Slider from 'primevue/slider';
import SpeedDial from "primevue/speeddial";
import SplitButton from 'primevue/splitbutton';
import TabMenu from "primevue/tabmenu";
import TabPanel from "primevue/tabpanel";
import TabView from "primevue/tabview";
import Textarea from "primevue/textarea";
import Toast from "primevue/toast";
import ToggleButton from "primevue/togglebutton";
import Tooltip from "primevue/tooltip";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";

import "@/assets/css/base.scss";
import "@/assets/css/theme.scss";
import "@/assets/css/material-symbols-outlined.scss";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "font-awesome-animation/css/font-awesome-animation.min.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";

library.add(fas);
library.add(far);

const app = createApp(App)

	.component("Badge", Badge)
	.component("Button", Button)
	.component("Calendar", Calendar)
	.component("Card", Card)
	.component("Carousel", Carousel)
	.component("Checkbox", Checkbox)
	.component("Column", Column)
	.component("ConfirmDialog", ConfirmDialog)
	.component("DataTable", DataTable)
	.component("Dialog", Dialog)
	.component("Divider", Divider)
	.component("Dropdown", Dropdown)
	.component("FileUpload", FileUpload)
	.component("InlineMessage", InlineMessage)
	.component("InputNumber", InputNumber)
	.component("InputSwitch", InputSwitch)
	.component("InputText", InputText)
	.component("Menu", Menu)
	.component("MultiSelect", MultiSelect)
	.component("OverlayPanel", OverlayPanel)
	.component("Paginator", Paginator)
	.component("Password", Password)
	.component("PickList", PickList)
	.component("ProgressBar", ProgressBar)
	.component("ProgressSpinner", ProgressSpinner)
	.component("RadioButton", RadioButton)
	.component("ScrollTop", ScrollTop)
	.component("SelectButton", SelectButton)
	.component("Skeleton", Skeleton)
	.component("Slider", Slider)
	.component("SpeedDial", SpeedDial)
	.component("SplitButton", SplitButton)
	.component("TabMenu", TabMenu)
	.component("TabPanel", TabPanel)
	.component("TabView", TabView)
	.component("Textarea", Textarea)
	.component("Toast", Toast)
	.component("ToggleButton", ToggleButton)
	
	.component("FontAwesomeIcon", FontAwesomeIcon)
	
	.directive('Tooltip', Tooltip)
	
	.use(PrimeVue, {ripple: true})
	.use(ConfirmationService)
	.use(ToastService)
	.use(router)
	.use(store);
	
app.directive('number', {
	beforeMount(el) {
		if (el.childNodes != null && el.childNodes.length > 0 && el.childNodes[0].value == '') {
			el.childNodes[0].value = 0;
		}

		el.clickOutsideEvent = function(event: any) {
			if (!(el === event.target || el.contains(event.target))) {
				if (el.childNodes != null && el.childNodes.length > 0 && el.childNodes[0].value == '') {
					el.childNodes[0].value = 0;
				}
			}
		};		
		document.body.addEventListener('click', el.clickOutsideEvent);
		
		el.blurEvent = function() {
			setTimeout(function() {
				if (el.childNodes != null && el.childNodes.length > 0 && el.childNodes[0].value == '') {
					el.childNodes[0].value = 0;
				}
			},0);
		};
		el.addEventListener('blur', el.blurEvent, true);
	},
	beforeUnmount(el) {
		el.removeEventListener('blur', el.blurEvent);
		document.body.removeEventListener('click', el.clickOutsideEvent);
	}
});
	
app.mount("#app");
